import { SVGAttributes } from 'react'

export function Play(props: SVGAttributes<SVGElement>): JSX.Element {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM15.0722 10.4949C14.663 10.2717 14.1641 10.5678 14.1641 11.0339V28.9651C14.1641 29.4312 14.663 29.7274 15.0722 29.5042L31.5091 20.5386C31.9358 20.3059 31.9358 19.6932 31.5091 19.4604L15.0722 10.4949Z'
      />
    </svg>
  )
}
